import React from "react";
import {SwitcherChildBlocks} from "./SwitcherChildBlocks";
import {SWITCH_DISPLAY_PERIOD_MARKETS} from "../../store/spirs/actions";
import { useDispatch, useSelector } from 'react-redux';
import { matchRouteParams, Sport, Tree } from '../../models/api/codegen/code';
import {useTranslation} from "react-i18next";
import {TreeDirectory} from "../tree/Tree";
import {useParams} from "react-router-dom";
import { makeSelectFilterTree } from '../VerticalMenu/selectors';
import { StoreType } from '../../store/spirs/types';


export const PrematchFilter: React.FC = () => {
    const params = useParams<matchRouteParams>();
    const status = 'NOT_STARTED';
    const selectFilteredTree = React.useMemo(makeSelectFilterTree, []);
    const tree = useSelector((state: StoreType)=> selectFilteredTree(state, params));
    const dispatch = useDispatch();
    const {t} = useTranslation();

    React.useEffect(() => {
        return () => {
            dispatch(SWITCH_DISPLAY_PERIOD_MARKETS(false));
        }
    }, []);

    return (
        <>
            <div className="flex justify-between bg-[#171A1E] rounded-[8px] py-[8px] pl-[12px] mb-[8px]">
                <div className="max-mobile:hidden">
                    <SwitcherChildBlocks/>
                </div>
            </div>
            {tree && <TreeDirectory tree={tree} mode={status} fullHeight={false}/>}
        </>
    )
};
